// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2GRO0","text":"SelectPayment_text__25mIh","title":"SelectPayment_title__2E8Fh","btn":"SelectPayment_btn__T_lAa"};